import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { downloadPdf } from "@/lib/documents";
import { requestRegCard } from "./RegCardOptions";
import { BTN_SOFT, BTN_SM } from "@/components/checkout/buttonStyles";

/** Shared "Download PDF" action — fetches the PDF as an attachment and saves it with the friendly filename. */
export function DownloadPdfButton({ url, filename, label = "Download", size = "sm", className = "", testId = "download-pdf-btn", iconOnly = false, regCard = false }) {
  const [busy, setBusy] = useState(false);
  const click = async (e) => {
    e.stopPropagation();
    if (busy) return;
    if (regCard) { requestRegCard({ url, filename, action: "download" }); return; }
    setBusy(true);
    try { await downloadPdf(url, filename); } catch { /* toast shown by downloadPdf */ }
    finally { setBusy(false); }
  };
  const sizing = size === "sm" ? `${BTN_SM} min-h-[44px] md:min-h-0 md:h-9` : "min-h-[44px]";
  return (
    <button type="button" onClick={click} disabled={busy} className={`${BTN_SOFT} ${sizing} [&_svg]:shrink-0 [&_svg]:w-[13px] [&_svg]:h-[13px] ${className}`} aria-label={label} title={label} data-testid={testId} data-busy={busy ? "1" : "0"}>
      {busy ? <Loader2 size={13} className="animate-spin" /> : <Download size={13} />}
      {!iconOnly && <span>{busy ? "Downloading…" : label}</span>}
    </button>
  );
}
